import { getProductName, getPricing, getEmptyProductPrice } from "../functions/product-model";
import { Constants } from "../functions/constants";
import { ArrayUtils } from "../functions/array-utils";
import { ObjectUtils } from "../functions/object-utils";
import { documentToDict } from "../functions/algolia-utils";
import { ProductDecorator } from "../functions/product-decorator";
import { RouteUtils } from "../functions/route-utils";
import { parseValue } from "../functions/product-model";

const cardMixin = {
    computed: {
        customDict: function () {
            if (this.model && this.model.customDict) {
                return this.model.customDict;
            }
            else if (this.model && this.model.Document) {
                return documentToDict(this.model.Document);
            }
            return {};
        },
        
        productDetails: function () {
            var options = {};
            if (this.firstProduct ?.Document)
                options.Document = this.firstProduct.Document;

            options = { ...options, ...this.model };
            if (ObjectUtils.isEmptyObject(options))
                return null;

            return new ProductDecorator(options);
        },
        firstProduct: function () {
            if (!this.searchOutput)
                return null;

            if (ArrayUtils.isNotEmpty(this.searchOutput.Results) === false)
                return null;

            return this.searchOutput.Results[0];
        },
        titleText: function () {
            let title = '';
            if (this.model ?.itemName)
                title = this.model.itemName;
            else if (this.customDict.name)
                title = this.customDict.name;


            return getProductName(title, this.customDict.type, this.customDict.brand);
        },
        detailUrl: function () {
            if (typeof this.customDict.url_detail === "string")
                if (this.customDict.url_detail.indexOf(GlobalApp.generalSettings.productDetailsPageUrl) === 0)
                    return `${RouteUtils.ensureNoTrailingSlash(this.customDict.url_detail)}`;
                else
                    return `${GlobalApp.generalSettings.productDetailsPageUrl}${RouteUtils.ensureNoTrailingSlash(this.customDict.url_detail)}`;
        },
        thumbnailUrl: function () {
            let thumbnailUrl = Constants.IMAGES.DEFAULT_THUMBNAIL_URL;
            if (typeof this.customDict.image === "string")
                { thumbnailUrl = this.customDict.image; }

            return thumbnailUrl;
        },
        thumbnailStaticUrl: function () {
            return Constants.IMAGES.DEFAULT_THUMBNAIL_STATIC_URL;
        },
        imageBackground: function () {
            return `background-image:url(${this.thumbnailUrl})`;
        },
        brand: function () {
            return this.customDict.brand;
        },
        productSku: function () {
            return this.customDict.sku;
        },
        productPricing: function () {
            if (!this.productDetails) 
                return getEmptyProductPrice();

            var pricingObject = this.productDetails.getPrices();
            var pricing = getPricing(pricingObject ?.price ?.value, pricingObject ?.retailPrice ?.value, pricingObject ?.salePrice ?.value);
            return pricing;
        },
        isParts: function () {
            if (!this.productDetails)
                return false;

            return this.productDetails.isPart();
        },
        brandName: function () {
            if (!this.productDetails)
                return "";

            return this.productDetails.getBrandName();
        },
        isVermeer: function () {
            if (!this.productDetails)
                return false;

            return this.productDetails.isVermeer();
        },
        isJohnDeere: function () {
            if (!this.productDetails)
                return false;

            return this.productDetails.isJohnDeere();
        },
        partProductLineIfUnderSpecialValidation: function () {
            if (!this.productDetails)
                return false;

            return this.productDetails.getPartProductLineIfUnderSpecialValidation();
        },
        entityId: function () {
            if (!this.productDetails)
                return false;

            return this.productDetails.getEntityId();
        },
        sku: function () {
            if (!this.productDetails)
                return false;

            return this.productDetails.getSku();
        },
        primaryCta: function () {
            var ctaValue = parseValue(this.customDict.cta_call_to_actionecommerce);
            return this.productDetails.getCta(ctaValue, this.isLoggedIn, this.requestQuoteDetail);
        },
        requestQuoteDetail: function () {
            var pageLink = null;

            if (this.productDetails.isNewEquipment())
                pageLink = { LinkUrl: '/equipment/new/request-a-quote', Title: Constants.ALGOLIA.PRODUCT.CTA.VALUE_REQUEST_QUOTE };

            else if (this.productDetails.isUsedEquipment())
                pageLink = { LinkUrl: '/equipment/used/request-a-quote', Title: Constants.ALGOLIA.PRODUCT.CTA.VALUE_REQUEST_QUOTE };

            return pageLink;
        },
        isPartWithSpecialAORValidation: function () {
            if (this.isParts === false)
                return false;

            let productLine = this.partProductLineIfUnderSpecialValidation;
            if (!productLine)
                return false;

            return true;
        },
        addProductData: function () {
            return this.customDict;
        },
    },
    methods: {
        emitClick(e, url, redirect) {
            const config = {
                "uniqueId": this.customDict.unique_id,
                "redirectUrl": url,
                "redirect": (redirect) ? true : false,
                "clickEvent:": e
            };

            this.$emit('clicked', config);
        },
        shouldShowPrice: function (isBusinessCustomer) {
            if (!this.productDetails)
                return false;

            return this.productDetails.shouldShowPrice(isBusinessCustomer);
        },
        productLineWithValidation: function () {
            if (this.isPartWithSpecialAORValidation === false)
                return "";

            if (ArrayUtils.isNotEmpty(this.myStore?.AreaOfResponsibility) === false)
                return "";

            let productLine = this.partProductLineIfUnderSpecialValidation;

            if (this.myStore.AreaOfResponsibility.includes(productLine))
                return productLine;

            return "";
        },
        updateIsOnlineBranch: function (isOnlineBranch) {
            if (isOnlineBranch === true) {
                this.isOnlineBranch = true;
            } else {
                this.isOnlineBranch = false;
            }
        },
        disableAddToCartButton: function () {
            this.addButtonDisabled = true
        },
        enableAddToCartButton: function () {
            this.addButtonDisabled = false
        },
    }
};

export default cardMixin;
